import React from 'react';
import { SignoutCallbackComponent } from "redux-oidc";
import { withRouter } from 'react-router-dom';
import userManager from "../../userManager";
import { clearForm } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";

const Logout = props => {
  const dispatch = useDispatch();
  const form = useSelector(state => state.form);
  return <SignoutCallbackComponent
    userManager={userManager}
    successCallback={(response) => {
      console.log("response", response);
      dispatch(clearForm());
      form.form === 'operator' ? props.history.push('/operator') : props.history.push('/tattooist-form');
    }}
    errorCallback={error => {
      console.error(error);
      dispatch(clearForm());
      form.form === 'operator' ? props.history.push('/operator') : props.history.push('/tattooist-form');
    }}
  >
    <div>Logging out...</div>
  </SignoutCallbackComponent>
}

export default withRouter(props => <Logout {...props} />);
